import React, {Component} from 'react';
import {browserHistory} from 'react-router';
import Location from './components/Location';
import { BASE_URL } from './constants/api';
import axios from 'axios';

class StepThree extends Component {
    constructor(props) {
        super(props);
        this.onBtnClickHandler = this.onBtnClickHandler.bind(this);
        this.handleOptionChange = this.handleOptionChange.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.onBtnBack = this.onBtnBack.bind(this);
        this.state = {
            selectedOption: 'existingaddress',
            userData: {},
            newAddress: {postal_code: '', firstaddr: '', city: '', states: '', phone_number: ''},
            validField: {},
            cities: [],
            indexedCities: {},
        }
    }

    onBtnBack(e) {
        e.preventDefault();
        browserHistory.push(`/StepTwo`)
    }

    componentWillMount() {
        let user = localStorage.getItem('user');
        if (!user) {
            browserHistory.push(`/StepOne`)
        } else {
            let data = localStorage.getItem('user');
            this.setState({userData: JSON.parse(data)});
            if (!JSON.parse(data).user_data.address) {
                this.setState({selectedOption: 'addressnew'});
            }
        }
    }

    async componentDidMount(){
        let config = {
            headers: {'Access-Token': JSON.parse(localStorage.getItem('user'))['token']}
        };

        axios.get(`${BASE_URL}/api/v1/cities`, config)
            .then((response) => {
                this.setState({
                    cities: response.data,
                    indexedCities: response.data.reduce((result, city) => {
                        return {...result, [city.name]: city};
                    }, {'': {name: ''}}),
                });
            });
    }

    validateByCity(postal_code) {
        const { indexedCities, newAddress } = this.state;
        const lower = postal_code.toLowerCase();

        return !!indexedCities[newAddress.city]
            .zip_codes
            .find(code => lower.startsWith(code.toLowerCase()));
    }

    validPostalCode(postal_code) {
        this.setState({validField: {'postal_code': ''}});
        const { indexedCities, newAddress } = this.state;

        if (!postal_code) {
            return 'empty';
        } else if (!indexedCities[newAddress.city].zip_codes) {
            return 'choose_city';
        } else if (postal_code.length !== 6 || !/([a-z]\d){3}/i.test(postal_code)) {
            return 'invalid_format';
        } else if (!this.validateByCity(postal_code)) {
            return 'invalid';
        } else {
            return '';
        }
    }

    validFirstAddr(firstaddr) {
        this.setState({validField: {'firstaddr': ''}});
        if (!firstaddr) {
            return 'empty';
        } else if (firstaddr.length > 50) {
            return 'long';
        } else {
            return ''
        }
    }

    validCity(city) {
        this.setState({validField: {'city': ''}});
        if (!city) {
            return 'empty';
        } else {
            return ''
        }
    }

    validState(states) {
        this.setState({validField: {'states': ''}});
        if (!states) {
            return 'empty';
        } else {
            return ''
        }
    }

    validPhoneNumber(phone_number) {
        this.setState({validField: {'phone_number': ''}});
        let phone = phone_number.replace(/[^0-9]/g, '');
        if (phone.length != 11) {
            return 'invalid';
        } else {
            return ''
        }
    }

    validParkingDetails(parking_details) {
        this.setState({validField: {'parking_details': ''}});
        if (!parking_details) {
            return 'empty';
        } else {
            return ''
        }
    }

    validStepThree(newAddress) {
        let valid = true;
        let data = {};
        data['postal_code'] = this.validPostalCode(newAddress.postal_code);
        data['firstaddr'] = this.validFirstAddr(newAddress.firstaddr);
        data['city'] = this.validCity(newAddress.city);
        // data['states'] = this.validState(newAddress.states);
        data['phone_number'] = this.validPhoneNumber(newAddress.phone_number);
        data['parking_details'] = this.validParkingDetails(newAddress.parking_details);
        this.setState({validField: data});

        for (let k in data) {
            if (data[k] != "") {
                this.setState({validField: Object.assign({}, this.state.validField, data)});
                valid = false;
            }
        }
        return valid
    }

    updateAddress(address) {
        let config = {
            headers: {'access-token': this.state.userData['token']}
        };

        axios.put(`${BASE_URL}/api/v1/user`, {
                user: {
                    address: address['firstaddr'],
                    city: address['city'],
                    postal_code: address['postal_code'],
                    phone_number: address['phone_number']
                }
            },
            config
        ).then(function (response) {
            let data = {
                token: response.headers['access-token'],
                user_data: response.data
            };
            localStorage.removeItem("user");
            localStorage.setItem('user', JSON.stringify(data))
        }).catch(function (error) {
            if (error.response.data.type == "Unauthorized") {
                localStorage.removeItem("servicesData");
                localStorage.removeItem("appointment_details");
                localStorage.removeItem("appointment");
                localStorage.removeItem("services");
                localStorage.removeItem("user");
                alert(error.response.data.type);
                browserHistory.push(`/StepOne`)
            } else {
                alert(error.response.data.message);
            }
        });
    }

    onBtnClickHandler(e) {
        e.preventDefault();
        let address = {};
        let data = {};

        if (this.state.selectedOption === 'addressnew' && this.validStepThree(this.state.newAddress)) {
            address = this.state.newAddress;
            data = {
                postal_code: address['postal_code'],
                phone_number: address['phone_number'],
                parking_details: address['parking_details'],
                address: address['firstaddr'],
                city: address['city']
            };
            localStorage.removeItem("appointment");
            localStorage.setItem('appointment', JSON.stringify(data));
            this.updateAddress(address);
            browserHistory.push(`/StepFour`);
        } else if (this.state.selectedOption !== 'addressnew') {
            address = this.state.userData;
            data = {
                postal_code: address['user_data']['postal_code'],
                phone_number: address['user_data']['phone_number'],
                city: address['user_data']['city'],
                address: address['user_data']['address']
            };
            localStorage.removeItem("appointment");
            localStorage.setItem('appointment', JSON.stringify(data));
            browserHistory.push(`/StepFour`);
        }
    }

    handleInputChange(propName, value) {
        let data = {};
        data[propName] = propName !== 'city' ? value : this.state.indexedCities[value].name;
        this.setState({newAddress: Object.assign({}, this.state.newAddress, data)});
    }

    handleOptionChange(changeEvent) {
        this.setState({selectedOption: changeEvent.target.value});
    }

    render() {
        let selectedOption = this.state.selectedOption;
        let address = '';
        if ('user_data' in this.state.userData && !!this.state.userData['user_data']['address']) {
            address = (
                this.state.userData['user_data']['address'] + ', ' +
                (this.state.userData['user_data']['city'] || '') + ', ' +
                this.state.userData['user_data']['postal_code']
            );
        }

        return (
            <div className="smart-wrap">
                <div className="smart-forms smart-container wrap-2">
                    <div className="form-header header-lite">
                        <h4>Location</h4>
                    </div>
                    <div className="form-body smart-steps steps-theme-primary">
                        <form method="post" action="#" id="smart-form">
                            <fieldset>
                                <div className="section">
                                    <div className="option-group field appointpage">
                                        {
                                            address &&
                                            <label className="option">
                                                <input
                                                    type="radio"
                                                    name="package"
                                                    className="smartfm-ctrl"
                                                    value="existingaddress"
                                                    data-show-id="existingaddress"
                                                    checked={this.state.selectedOption === 'existingaddress'}
                                                    onChange={this.handleOptionChange}
                                                />
                                                <span className="radio"></span> {address}
                                            </label>
                                        }
                                        <label className="option">
                                            <input
                                                type="radio"
                                                name="package"
                                                className="smartfm-ctrl"
                                                value="addressnew"
                                                data-show-id="addressnew"
                                                checked={this.state.selectedOption === 'addressnew'}
                                                onChange={this.handleOptionChange}
                                            />
                                            <span className="radio"></span> Add New Address
                                        </label>
                                    </div>
                                </div>
                                {
                                    selectedOption === 'addressnew' &&
                                    <Location
                                        cities={this.state.cities}
                                        validField={this.state.validField}
                                        handleInputChange={this.handleInputChange}
                                    />
                                }
                                <div className="controls">
                                    <div className="sendit">
                                        <button
                                            type="submit"
                                            className="button btn-primary"
                                            onClick={this.onBtnClickHandler}
                                        > CONTINUE
                                        </button>
                                    </div>
                                </div>
                                <div className="text-center backer">
                                    <a
                                        href="#"
                                        className="back"
                                        onClick={this.onBtnBack}
                                    >&larr;  Back</a></div>
                            </fieldset>
                        </form>
                    </div>
                </div>
            </div>)
    }
}

export default StepThree;



/** WEBPACK FOOTER **
 ** ./src/StepThree.js
 **/